"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScholarshipCardImpressionData = void 0;
const ecommerce_tracking_data_class_1 = require("./ecommerce-tracking-data.class");
class ScholarshipCardImpressionData extends ecommerce_tracking_data_class_1.EcommerceTrackingData {
    constructor(productId, bodyId, listPageType, listName, organisationId, disciplines, premium, listPosition, unitPrice, currency) {
        super(productId, listPageType, listName, organisationId, disciplines, premium, listPosition, unitPrice, currency);
        this.productId = productId;
        this.bodyId = bodyId;
        this.listPageType = listPageType;
        this.listName = listName;
        this.organisationId = organisationId;
        this.disciplines = disciplines;
        this.premium = premium;
        this.listPosition = listPosition;
        this.unitPrice = unitPrice;
        this.currency = currency;
    }
    getTrackingContext() {
        var _a, _b;
        return {
            organisationId: this.getOrganisationId(),
            studyId: undefined,
            scholarshipId: this.getProductId(),
            bodyId: this.bodyId,
            premiumnessLevel: (_b = (_a = this.premium) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
            price: this.getUnitPrice(),
            position: this.listPosition,
            currency: this.getCurrency()
        };
    }
}
exports.ScholarshipCardImpressionData = ScholarshipCardImpressionData;
